<div
  class="hero-carousel-interactive"
  role="region"
  aria-label="Carrusel de productos"
>
  @if (!isBrowser) {
  <!-- Start::SSR - Solo lo CRÍTICO para SEO/LCP -->
  <figure class="hero-carousel-interactive__figure">
    <img
      [ngSrc]="stateService.getCurrentSlideImage(slides[0])"
      [alt]="slides[0].alt"
      fill
      sizes="100vw"
      priority
      fetchpriority="high"
      decoding="sync"
      class="hero-carousel-interactive__image"
    />
  </figure>
  <!-- End::SSR - Solo lo CRÍTICO para SEO/LCP -->
  } @else {
  <!-- Start::BROWSER - Carousel completo -->

  <p-carousel
    [value]="slides"
    [numVisible]="1"
    [numScroll]="1"
    [autoplayInterval]="config.carousel.autoplayInterval"
    [circular]="true"
    [showIndicators]="true"
    [showNavigators]="true"
  >
    <ng-template let-slide pTemplate="item">
      <article
        class="hero-carousel-interactive__slide"
        itemscope
        itemtype="https://schema.org/Product"
        [attr.itemprop]="'itemListElement'"
        [attr.data-position]="slide.index + 1"
        [attr.aria-label]="
          'Slide ' + (slide.index + 1) + ' de ' + slides.length
        "
      >
        <a
          [href]="slide.url"
          (click)="onSlideClick(slide, slide.index, $event)"
          class="hero-carousel-interactive__link"
          [attr.aria-label]="'Ver oferta de ' + slide.alt"
          [attr.tabindex]="slide.index === 0 ? null : -1"
          itemProp="url"
        >
          <figure class="hero-carousel-interactive__figure">
            @if (slide.index === 0) {
            <img
              [ngSrc]="stateService.getCurrentSlideImage(slide)"
              [alt]="'Producto en oferta: ' + slide.title"
              fill
              sizes="100vw"
              priority
              fetchpriority="high"
              decoding="sync"
              class="hero-carousel-interactive__image hero-carousel-interactive__image--priority"
              itemProp="image"
            />

            } @else {
            <img
              [ngSrc]="stateService.getCurrentSlideImage(slide)"
              [alt]="'Producto en oferta: ' + slide.title"
              fill
              sizes="100vw"
              [loading]="slide.index <= 1 ? 'eager' : 'lazy'"
              fetchpriority="auto"
              decoding="async"
              class="hero-carousel-interactive__image"
              itemProp="image"
            />
            } @if (slide.title) {
            <figcaption class="sr-only" itemProp="name">
              {{ slide.title }}
            </figcaption>
            }
          </figure>
        </a>
      </article>
    </ng-template>
  </p-carousel>
  <!-- End::BROWSER - Carousel completo -->
  }

  <!-- Start::Structured data - siempre disponible (SSR + Browser) -->
  <script
    type="application/ld+json"
    [innerHTML]="stateService.getStructuredData()"
  ></script>
  <!-- End::Structured data - siempre disponible (SSR + Browser) -->
</div>
